/* eslint-disable import/prefer-default-export */
// dark icons
import { ReactComponent as RegularAirFreightDark } from "assets/images/icons/RegularAirFreightDark.svg";
import { ReactComponent as AirCharterDark } from "assets/images/icons/AirCharterDark.svg";
import { ReactComponent as NextFlightOutDark } from "assets/images/icons/NextFlightOutDark.svg";
import { ReactComponent as OceanFreightDark } from "assets/images/icons/OceanFreightDark.svg";
import { ReactComponent as OnBoardCourierDark } from "assets/images/icons/OnBoardCourierDark.svg";
import { ReactComponent as ParcelIconDark } from "assets/images/icons/ParcelDark.svg";
import { ReactComponent as RailFreightDark } from "assets/images/icons/RailFreightDark.svg";
import { ReactComponent as RoadFreightDark } from "assets/images/icons/RoadFreightDark.svg";
// light icons
import { ReactComponent as RegularAirFreightLight } from "assets/images/icons/RegularAirFreightLight.svg";
import { ReactComponent as AirCharterLight } from "assets/images/icons/AirCharterLight.svg";
import { ReactComponent as NextFlightOutLight } from "assets/images/icons/NextFlightOutLight.svg";
import { ReactComponent as OceanFreightLight } from "assets/images/icons/OceanFreightLight.svg";
import { ReactComponent as OnBoardCourierLight } from "assets/images/icons/OnBoardCourierLight.svg";
import { ReactComponent as ParcelIconLight } from "assets/images/icons/ParcelLight.svg";
import { ReactComponent as RailFreightLight } from "assets/images/icons/RailFreightLight.svg";
import { ReactComponent as RoadFreightLight } from "assets/images/icons/RoadFreightLight.svg";
import { isProviderEntrySelected } from "./requestFormProvider";

const FreightModeIconsByValue = {
  "Regular air freight": (dark) => (dark ? RegularAirFreightDark : RegularAirFreightLight),
  "On board courier (OBC)": (dark) => (dark ? OnBoardCourierDark : OnBoardCourierLight),
  "Next flight out (NFO)": (dark) => (dark ? NextFlightOutDark : NextFlightOutLight),
  "Air charter": (dark) => (dark ? AirCharterDark : AirCharterLight),
  "Ocean freight": (dark) => (dark ? OceanFreightDark : OceanFreightLight),
  Parcel: (dark) => (dark ? ParcelIconDark : ParcelIconLight),
  "Rail freight": (dark) => (dark ? RailFreightDark : RailFreightLight),
  "Road freight": (dark) => (dark ? RoadFreightDark : RoadFreightLight),
  "Consolidated Air": (dark) => (dark ? RegularAirFreightDark : RegularAirFreightLight),
};

const FreightModeIconsByType = {
  air: (dark) => (dark ? RegularAirFreightDark : RegularAirFreightLight),
  ocean: (dark) => (dark ? OceanFreightDark : OceanFreightLight),
  parcel: (dark) => (dark ? ParcelIconDark : ParcelIconLight),
  rail: (dark) => (dark ? RailFreightDark : RailFreightLight),
  road: (dark) => (dark ? RoadFreightDark : RoadFreightLight),
};

export const getFreightModeIcon = (value, type = "", isDark = false) => {
  const iconFn = FreightModeIconsByValue[value] || FreightModeIconsByType[type];
  if (!iconFn) {
    return FreightModeIconsByType.parcel(isDark);
  }
  return iconFn(isDark);
};

export const selectedFreightMode = (available_modes, invited_modes) => {
  if (!available_modes) {
    return [];
  }
  let selectedModes = [];
  if (invited_modes && Object.keys(invited_modes).length) {
    selectedModes =
      Object.keys(invited_modes).filter(
        (key) => typeof invited_modes[key] === "boolean" && invited_modes[key] && !key.includes("custom"),
      ) || [];
    if (invited_modes.custom && invited_modes.custom.length) {
      invited_modes.custom.forEach((item) => {
        if (item.value) {
          selectedModes.push(`custom_${item.key}`);
        }
      });
    }
  }
  return selectedModes.map((item) => available_modes[item]).filter((item) => Boolean(item));
};

export const getFreightModeLabel = (intl) => ({
  OBC: intl.formatMessage({
    id: "settings.payment-locations.onBoardCourier",
    defaultMessage: "On board courier (OBC)",
  }),
  NFO: intl.formatMessage({
    id: "settings.payment-locations.nextFlightOut",
    defaultMessage: "Next flight out (NFO)",
  }),
  regular_air: intl.formatMessage({
    id: "settings.payment-locations.regularAirFreight",
    defaultMessage: "Regular air freight",
  }),
  air_charter: intl.formatMessage({
    id: "settings.payment-locations.airCharter",
    defaultMessage: "Air charter",
  }),
  ocean_freight: intl.formatMessage({
    id: "settings.payment-locations.oceanFreight",
    defaultMessage: "Ocean freight",
  }),
  parcel: intl.formatMessage({
    id: "settings.payment-locations.parcel",
    defaultMessage: "Parcel",
  }),
  rail_freight: intl.formatMessage({
    id: "settings.payment-locations.railFreight",
    defaultMessage: "Rail freight",
  }),
  road_freight: intl.formatMessage({
    id: "settings.payment-locations.roadFreight",
    defaultMessage: "Road freight",
  }),
});

export const selectedProvider = (availableProvider, selectedProviderIds) => {
  const providers =
    availableProvider?.length > 0 &&
    availableProvider?.filter((provider) => isProviderEntrySelected(provider, selectedProviderIds || []));
  return providers;
};
